import { Outlet } from "react-router-dom";
import { useEffect } from "react";

const BlankLayout = () => {

  useEffect(() => {
    if (window.RocketChat) {
      window.RocketChat(function() {
        this.hideWidget();
      });
    }
  }, []);

  return (
    <>
      <Outlet />
    </>
  );
};

export default BlankLayout;
